import { Flex } from 'components/elements'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

const TabContent = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props

  return (
    <Flex
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </Flex>
  )
}

export default TabContent
